export default __webpack_public_path__ + "static/media/P1000_Tip_Box.1d84ffaa.svg";